import { Box, Theme, Typography } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { SavingData } from '../../../../types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      padding: theme.spacing(1),
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
      marginTop: theme.spacing(3),
    },
    row: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(2),
    },
    label: {
      flex: 1,
    },
    tile: {
      backgroundColor: 'white',
      borderRadius: '24px',
      boxShadow: '0px 2px 16px 1px rgba(0, 0, 0, 0.12)',
      padding: theme.spacing(2),
      textAlign: 'center',
      width: 110,
    },
  })
);

const SavingsRow = ({
  title,
  color,
  lastWeek,
  lastMonth,
}: {
  title: React.ReactNode;
  color: 'primary' | 'secondary';
  lastWeek: number;
  lastMonth: number;
}) => {
  const classes = useStyles();
  return (
    <Box className={classes.row}>
      <Typography variant="h6" fontWeight={600} color={color} className={classes.label}>
        {title}
      </Typography>
      {[
        { value: lastWeek, caption: 'Last Week' },
        { value: lastMonth, caption: 'Last Month' },
      ].map(({ value, caption }) => (
        <Box key={caption} className={classes.tile}>
          <Typography variant="h6" fontWeight={600} color={color}>
            {value.toFixed(1)}
          </Typography>
          <Typography variant="caption" fontWeight={700}>
            {caption}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

const Savings = ({ savingData }: { savingData: SavingData }) => {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <SavingsRow
        title={
          <>
            Kg CO<sup>2</sup> Savings
          </>
        }
        color="secondary"
        lastWeek={savingData.kgO2Saving.lastWeek}
        lastMonth={savingData.kgO2Saving.lastMonth}
      />
      <SavingsRow
        title={
          <>
            Mileage<sup>km</sup> Savings
          </>
        }
        color="primary"
        lastWeek={savingData.kmSaving.lastWeek}
        lastMonth={savingData.kmSaving.lastMonth}
      />
    </Box>
  );
};

export default Savings;
